import { Button, Form, Input, InputNumber, Select, notification } from "antd";
import { useForm } from "antd/lib/form/Form";
import { useEffect, useState } from "react";
import TextArea from "antd/lib/input/TextArea";
import {
  createProductTemps,
  updateProductTemps,
} from "features/productTempSlice";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { PayloadType, TypeDataShared, SelectOptionType } from "type";
import * as yup from "yup";
import queryString from "query-string";
import { getTypeGroups } from "features/typeDataSharedSlice";
import { getSharedDatas } from "features/sharedDataSlice";
import NumberFormat from "react-currency-format";

interface CUMedicineProp {
  getListMedicine?: any;
  rowUpdate?: any;
  setRowUpdate?: any;
  typeGroupId: any;
  query: any;
}
function CUMedicine({
  typeGroupId,
  getListMedicine,
  rowUpdate,
  setRowUpdate,
  query,
}: CUMedicineProp) {
  const dispatch = useDispatch();
  const [form] = useForm();
  const [listDV, setListDV] = useState<SelectOptionType[]>([]);

  //validate
  const MedicineSchema = yup.object().shape({
    code: yup.string().required("Mã thuốc không được để trống!"),
    name: yup.string().required("Tên thuốc không được để trống!"),
    price: yup.string().required("Giá tiền không được để trống!"),
    supplier: yup.string().required("Nhà cung cấp không được để trống!"),
    unitId: yup.string().required("Đơn vị tính không được để trống!"),
  });
  const yupSync = {
    async validator({ field }: any, value: any) {
      await MedicineSchema.validateSyncAt(field, { [field]: value });
    },
  };

  const initValues = rowUpdate
    ? {
        ...rowUpdate,
        unitId: rowUpdate.unitId.id,
      }
    : {
        code: "",
        name: "",
        supplier: "",
        price: undefined,
        unitId: undefined,
        description: "",
      };

  function formatNumber(input: any) {
    // Loại bỏ tất cả dấu phẩy hiện tại
    const sanitizedInput = input.replace(/,/g, "");

    // Kiểm tra xem chuỗi có chứa dấu phẩy hay không
    if (sanitizedInput.includes(".")) {
      // Nếu có dấu chấm, sử dụng locale 'en-US' cho tiếng Anh Mỹ
      return parseFloat(sanitizedInput).toLocaleString("en-US");
    } else {
      // Nếu không có dấu chấm, sử dụng locale 'vi-VN' cho tiếng Việt
      return parseFloat(sanitizedInput).toLocaleString("vi-VN");
    }
  }

  //create handle
  function handleCreateMedicine(values: any) {
    const priceString = values.price;
    const priceNumber = formatNumber(priceString);

    const dataBody = {
      ...values,
      price: priceNumber, // Thay thế trường "price" bằng giá trị số
    };

    const payload: PayloadType = {
      body: {
        ...dataBody,
        productTypeId: typeGroupId,
      },
      callback: {
        success(values) {
          notification.success({
            message: "Tạo mới danh mục tên thuốc thành công!",
          });
          form.resetFields();
          getListMedicine(typeGroupId, query);
        },
        failed(errorMessage) {
          if (errorMessage?.includes("duplicate key")) {
            notification.error({
              message: "Tạo mới danh mục thuốc thất bại!",
              description: "Mã thuốc đã tồn tại!",
            });
            return;
          }
          notification.error({
            message: "Tạo mới danh mục thuốc thất bại!",
            description: errorMessage,
          });
        },
      },
    };
    dispatch(createProductTemps(payload));
  }
  //update handle
  function handleUpdateMedicine(values: TypeDataShared) {
    const payload: PayloadType = {
      params: _.get(rowUpdate, "id", ""),
      body: {
        ...values,
        productTypeId: typeGroupId,
      },
      callback: {
        success(values) {
          notification.success({
            message: "Cập nhật danh mục thuốc thành công!",
          });
          setRowUpdate(null);
          form.resetFields();
          getListMedicine(typeGroupId, query);
          form.resetFields();
        },
        failed(errorMessage) {
          if (errorMessage?.includes("duplicate key")) {
            notification.error({
              message: "Cập nhật danh mục thuốc thất bại!",
              description: "Tên danh mục thuốc đã tồn tại!",
            });
            return;
          }
          notification.error({
            message: "Cập nhật danh mục thuốc thất bại!",
            description: errorMessage,
          });
        },
      },
    };
    dispatch(updateProductTemps(payload));
  }

  // lấy danh sách đơn vị
  const getFieldDV = () => {
    const payload: PayloadType = {
      query: queryString.stringify({
        page: 1,
        limit: 999,
        code: `MEDICINE_UNIT`,
      }),
      skipUpdateReducer: true,
      callback: {
        success(roleId) {
          const results = _.get(roleId, "results", []);
          const typeGroupId = _.get(results, "[0].id", null);
          const payload1: PayloadType = {
            query: queryString.stringify({
              page: 1,
              limit: 999,
              typeGroupId: typeGroupId,
            }),
            callback: {
              success(results) {
                const listDV = results.results;
                if (!!listDV && Array.isArray(listDV)) {
                  setListDV(
                    listDV.map((item: any) => {
                      return {
                        label: item.name,
                        value: item.id,
                      };
                    })
                  );
                }
              },
              failed() {},
            },
          };
          dispatch(getSharedDatas(payload1));
        },
        failed() {},
      },
    };
    dispatch(getTypeGroups(payload));
  };
  // useEffect(() => {
  //   getFieldDV();
  // }, []);

  const resetForm = () => {
    form.resetFields();
    setRowUpdate(null);
  };

  useEffect(() => {
    if (!rowUpdate) {
      form.resetFields();
    }
    if (!_.isEmpty(rowUpdate)) {
      getFieldDV();
    }
    form.setFieldsValue({
      ...rowUpdate,
    });
    form.setFieldValue("unitId", rowUpdate?.unitId?.id);
  }, [rowUpdate]);

  return (
    <Form
      labelCol={{ span: 16 }}
      layout="vertical"
      initialValues={initValues}
      labelAlign="left"
      form={form}
      onFinish={
        Object.keys(rowUpdate ?? {}).length === 0
          ? handleCreateMedicine
          : handleUpdateMedicine
      }
    >
      <Form.Item required label={"Mã thuốc "} name={"code"} rules={[yupSync]}>
        <Input placeholder="Nhập vào mã thuốc" disabled={!!rowUpdate} />
      </Form.Item>

      <Form.Item required label={"Tên thuốc"} name={"name"} rules={[yupSync]}>
        <Input placeholder="Nhập tên thuốc" />
      </Form.Item>
      <Form.Item label={"Nhà cung cấp"} name={"supplier"} rules={[yupSync]}>
        <Input placeholder="Nhập tên nhà cung cấp" />
      </Form.Item>

      <Form.Item label={"Giá tiền (vnđ)"} name={"price"} rules={[yupSync]}>
        <Input placeholder="Nhập giá" type="number" />
      </Form.Item>
      <Form.Item
        label={"Đơn vị tính"}
        name={"unitId"}
        rules={[yupSync]}
        required
      >
        {/* !!!! */}
        <Select
          placeholder="Chọn đơn vị tính"
          style={{ width: "100%" }}
          options={listDV}
          onClick={() => getFieldDV()}
        />
      </Form.Item>

      <Form.Item label={"Ghi chú"} name={"description"}>
        <TextArea rows={3} placeholder={"Nhập ghi chú"} />
      </Form.Item>
      <div
        className="ant-modal-footer"
        style={{ padding: "10px 0px", textAlign: "center" }}
      >
        <Button onClick={resetForm} style={{ width: "48%" }}>
          Huỷ bỏ
        </Button>
        <Button style={{ width: "48%" }} type="primary" htmlType="submit">
          Lưu lại
        </Button>
      </div>
    </Form>
  );
}
export default CUMedicine;
